import { HttpClient, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';

import { environment } from '../../../environments/environment';

@Injectable({
  providedIn: 'root',
})
export class VehicleSearchService {
  baseUrl: string = environment.baseUrl;
  constructor(private http: HttpClient) {}

  getVehicleSearchHistory(page: any, limit: any): Observable<any> {
    return this.http.get(
      `${this.baseUrl}/vehicle/history?page=${page}&size=${limit}`,
    );
  }

  searchVehicle(payload: any) {
    return this.http.post(`${this.baseUrl}/vehicle/search`, payload);
  }

  deleteVehicleSearchHistory(payload: any) {
    return this.http.delete(`${this.baseUrl}/vehicle/delete`, {
      body: payload,
    });
  }

  getCompletedSearchResult(searchId: any) {
    return this.http.get(
      `${this.baseUrl}/vehicle/results?vehicle_search_id=${searchId}`,
    );
  }

  getSearchResults(jobIds: string[]): Observable<any> {
    return this.http.get(`${this.baseUrl}/vehicle/job?job_id=${jobIds[0]}`);
  }

  updateVehicleNotes(payload: any): Observable<any> {
    return this.http.put(`${this.baseUrl}/vehicle/update`, payload);
  }
}
